import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  obj2vqjd1bjrpmyg as obj,
  nullable1in0t8o94jx9t as nullable,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import {
  Data1ybn66w6c74sz as Data,
  CreateSecretg99oj6r6hso0 as CreateSecret,
} from '../CreateSecretMutation.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { listOf1jh22dvmctj1r as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_secretIdAdapter1o4zeaz9dqdiz as get_secretIdAdapter } from '../../adapter/Adapter.mjs';
import { KotlinInstantAdapter_instancedmy0d2wf294o as KotlinInstantAdapter_instance } from '../../../../../../../apollo-kotlin-adapters-apollo-adapters-core/com/apollographql/adapter/core/KotlinInstantAdapter.mjs';
import { missingField4n9ldh7pi82p as missingField } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Assertions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.g6h_1 = listOf('createSecret');
      }
      s3z(reader, customScalarAdapters) {
        var _createSecret = null;
        $l$loop: while (true) {
          if (reader.k4c(this.g6h_1) === 0)
            _createSecret = nullable(obj(CreateSecret_getInstance())).s3z(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_createSecret);
      }
      h6h(writer, customScalarAdapters, value) {
        writer.v47('createSecret');
        nullable(obj(CreateSecret_getInstance())).x3z(writer, customScalarAdapters, value.b6e_1);
      }
      t3z(writer, customScalarAdapters, value) {
        return this.h6h(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
var CreateSecretClass;
function CreateSecret_0() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor() {
        CreateSecret_instance = this;
        this.i6h_1 = listOf_0(['secretId', 'description', 'createdTimestamp', 'lastUsedTimestamp', 'secretToken']);
      }
      s3z(reader, customScalarAdapters) {
        var _secretId = null;
        var _description = null;
        var _createdTimestamp = null;
        var _lastUsedTimestamp = null;
        var _secretToken = null;
        $l$loop: while (true) {
          switch (reader.k4c(this.i6h_1)) {
            case 0:
              _secretId = get_secretIdAdapter().s3z(reader, customScalarAdapters);
              break;
            case 1:
              _description = get_StringAdapter().s3z(reader, customScalarAdapters);
              break;
            case 2:
              _createdTimestamp = KotlinInstantAdapter_instance.s3z(reader, customScalarAdapters);
              break;
            case 3:
              _lastUsedTimestamp = nullable(KotlinInstantAdapter_instance).s3z(reader, customScalarAdapters);
              break;
            case 4:
              _secretToken = get_StringAdapter().s3z(reader, customScalarAdapters);
              break;
            default:
              break $l$loop;
          }
        }
        var tmp1_elvis_lhs = _secretId;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          missingField(reader, 'secretId');
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp_0 = tmp;
        var tmp2_elvis_lhs = _description;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          missingField(reader, 'description');
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var tmp_2 = tmp_1;
        var tmp3_elvis_lhs = _createdTimestamp;
        var tmp_3;
        if (tmp3_elvis_lhs == null) {
          missingField(reader, 'createdTimestamp');
        } else {
          tmp_3 = tmp3_elvis_lhs;
        }
        var tmp_4 = tmp_3;
        var tmp_5 = _lastUsedTimestamp;
        var tmp4_elvis_lhs = _secretToken;
        var tmp_6;
        if (tmp4_elvis_lhs == null) {
          missingField(reader, 'secretToken');
        } else {
          tmp_6 = tmp4_elvis_lhs;
        }
        return new (CreateSecret())(tmp_0, tmp_2, tmp_4, tmp_5, tmp_6);
      }
      j6h(writer, customScalarAdapters, value) {
        writer.v47('secretId');
        get_secretIdAdapter().t3z(writer, customScalarAdapters, value.c6e_1);
        writer.v47('description');
        get_StringAdapter().t3z(writer, customScalarAdapters, value.d6e_1);
        writer.v47('createdTimestamp');
        KotlinInstantAdapter_instance.y4d(writer, customScalarAdapters, value.e6e_1);
        writer.v47('lastUsedTimestamp');
        nullable(KotlinInstantAdapter_instance).x3z(writer, customScalarAdapters, value.f6e_1);
        writer.v47('secretToken');
        get_StringAdapter().t3z(writer, customScalarAdapters, value.g6e_1);
      }
      t3z(writer, customScalarAdapters, value) {
        return this.j6h(writer, customScalarAdapters, value instanceof CreateSecret() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'CreateSecret', VOID, VOID, [Adapter()]);
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CreateSecret_instance;
function CreateSecret_getInstance() {
  if (CreateSecret_instance === VOID)
    new (CreateSecret_0())();
  return CreateSecret_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance34t53wgrn3an7,
};
//endregion

//# sourceMappingURL=CreateSecretMutation_ResponseAdapter.mjs.map
